import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const HomePage = lazy(() =>
  import('./pages/HomePage').then((module) => ({ default: module.HomePage })),
);

export const homeRoutes: RouteObject[] = [
  {
    element: createElement(ProtectedRoute),
    children: [{ index: true, element: createElement(HomePage) }],
  },
];
